<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-date-picker size="small" v-model="formDatas2.ijdwYear" type="year" value-format="yyyy"
                        placeholder="选择年份" @change="partserch2" style="width: 150px;">
                    </el-date-picker>
                    <el-select size="small" v-model="formDatas2.ijdwMonth"  filterable clearable 
                        placeholder="请选择月份" @change="partserch2">
                        <el-option v-for="(item, index) in getMonth || []" :label="item.name" :value="item.id"
                            :key="item.id"></el-option>
                    </el-select>
                 
                    <el-select size="small" v-model="iuIds" multiple filterable clearable 
                        placeholder="请选择面试官" collapse-tags  @change="partserch"  v-if="iuPost == 2">
                        <el-option v-for="(item, index) in getIvUserList_data || []" :label="item.iuName" :value="item.iuId"
                            :key="item.iuId" :style="{ 'color': item.dmDelete == 2 ? 'red' : '' }"></el-option>
                    </el-select>
                    <el-select size="small" v-model="ijdwIds" multiple filterable clearable  placeholder="请选择统计周" style="width: 330px"
                    @change="partserch" collapse-tags>
                        <el-option v-for="(item, index) in getIvJobDateWeekList_data || []"
                            :label="item.ijdwDateStart + '  -  ' + item.ijdwDateEnd" :value="item.ijdwId"
                            :key="item.ijdwId"></el-option>
                    </el-select>
                  
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="small" style="margin-left: 10px;"
                        @click="businessOpportunitiesClicks()">转商机申请</el-button> -->
                    <!-- <el-button type="primary" size="small" style="margin-left: 10px;"
                        @click="claimClicks(4)">批量审核</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新建统计周</el-button>
                    <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen2">新建年度</el-button> -->
                    <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData.length > 0" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="tjId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <!-- <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
                        :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div> -->
            </div>
            <!-- 新增 -->
            <el-dialog :title="edit ? '编辑统计周' : '新增统计周'" :visible.sync="dialog" width="70%" top="8vh">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:65vh">
                    <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="周开始" prop="ijdwDateStart">
                            <el-date-picker v-model="form.ijdwDateStart" type="date" value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="周结束" prop="ijdwDateEnd">
                            <el-date-picker v-model="form.ijdwDateEnd" type="date" value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="排序" prop="ijdwOrder">
                            <el-input v-model="form.ijdwOrder" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 新增年度所有周 -->
            <el-dialog title="新增年度所有周" :visible.sync="dialog2" width="70%" top="8vh">
                <el-form ref="formRef2" :model="form2" label-position="top" :rules="rules" style="height:65vh">
                    <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="年份" prop="ijdwYear">
                            <el-date-picker v-model="form2.ijdwYear" type="year" value-format="yyyy" placeholder="选择年份">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose2">取 消</el-button>
                    <el-button type="primary" @click="SureBtn2">确 定</el-button>
                </span>
            </el-dialog>
        </div>

    </div>
</template>
  
<script>
import qs from 'qs';
import axios from 'axios';
import saveAs from 'file-saver';
import config from '../../api/env.js';
import {
    addIvJobDateWeek, deleteIvJobDateWeek, getIvJobDateWeekList, updateIvJobDateWeek,
    addIvJobDateWeekYear, getIvUserList, getIvJobApplicantAnalysis

} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            getMonth:[{
                name:'一月',id:1,
            },
            {
                name:'二月',id:2,
            },
            {
                name:'三月',id:3,
            },
            {
                name:'四月',id:4,
            },
            {
                name:'五月',id:5,
            },
            {
                name:'六月',id:6,
            },
            {
                name:'七月',id:7,
            },
            {
                name:'八月',id:8,
            },
            {
                name:'九月',id:9,
            },
            {
                name:'十月',id:10,
            },
            {
                name:'十一月',id:11,
            },
            {
                name:'十二月',id:12,
            },],
            tjIds: '',
            iuIds: '',
            getIvUserList_data: [],
            getIvJobDateWeekList_data: [],
            postForm: {
            },
            userarr: [],
            level_Four: [],
            level_Three: [],
            key: 'tjId',
            dialog: false,
            dialog2: false,
            edit: false,
            form: {

            },
            form2: {
                ijdwYear: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },



            ], //表格的列
            tableData: [],
            post: null,
            formDatas2: {
                ijdwYear: '',
                ijdwMonth: '',
                pageSize: 0,
            },
            formDatas: {
                ijdwIds: [],
                iuIds: [],
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.iuPost = localStorage.getItem("iuPost");
        // this.getList();
        this.getList2()
        getIvUserList({ iuPost: 1,iuJoinInterview: 2 }).then(res => {
            this.getIvUserList_data = res.data
        })
        this.getPost('industry')
    },
    mounted() { },
    methods: {
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out() {
                const bulkdata = {
                    //    iaIds: this.selectedRowKeysCollection.toString(),
                    ijdwIds: this.ijdwIds.toString(),
                    iuIds: this.iuIds.toString(),
                    ...this.formDatas
                }
                this.openLoading();
                var s = qs.stringify(bulkdata);
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/iv-home/exportIvJobApplicantAnalysis',
                    data: s,
                    withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('iuId')
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '招聘统计.xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
        },



        getPost(key) {
            const userpost = JSON.parse(sessionStorage.getItem('userPost')) || [];
            userpost.forEach((item, index) => {
                if (item.nsaMenuKey == key) {
                    this.postForm[item.nsaFuncKey] = item.nsaFuncLabel
                }
            })
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteIvJobDateWeek({ ijdwId: row.ijdwId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addIvJobDateWeek(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateIvJobDateWeek(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        SureBtn2() {

            this.$confirm("是否确定要新增, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    addIvJobDateWeekYear(this.form2).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "新增成功!",
                            });
                            this.handleClose2()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })


        },
        BoxOpen() {
            this.dialog = true;
        },
        BoxOpen2() {
            this.dialog2 = true;
        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        handleClose2() {
            this.dialog2 = false;
            this.$refs['formRef2'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.ijdwId = row.ijdwId
                    //console.log(jsonObj);
                    updateIvJobDateWeek(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(index, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {
            const rowKey = row[key];
            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getIvJobApplicantAnalysis(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch2() {
            this.formDatas.ijdwYear = this.formDatas2.ijdwYear
            this.formDatas.ijdwMonth = this.formDatas2.ijdwMonth
            getIvJobDateWeekList(this.formDatas2).then((res) => {
                this.getIvJobDateWeekList_data = res.data;
                this.resetSelectedRowKeys(this.key);
                this.partserch() 
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.formDatas.iuIds = this.iuIds ? this.iuIds.toString() : '';
            this.formDatas.ijdwIds = this.ijdwIds ? this.ijdwIds.toString() : '';
            this.tableData = [];
            this.columns =  [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },



            ]
            // if(this.ijdwIds == '')return
            getIvJobApplicantAnalysis(this.formDatas).then((res) => {
                res.data.header.forEach((item,index)=>{
                    if(index==0){
                        const s = {
                            field: index+1,
                            key: index+'',
                            fixed: 'left',
                            title: item,
                            width:150,
                            align: "center",
                        }
                        this.columns.push(s)
                    }else{
                        const s = {
                            field: index+1,
                            key: index+'',
                            title: item,
                            width:150,
                            align: "center",
                        }
                        this.columns.push(s)
                    }
                })
                res.data.list.forEach((item,index)=>{
                    const str = {}
                    item.forEach((item,indexs)=>{
                        str.tjId = index
                        str[indexs+1] =item
                    })
                    this.tableData.push(str)
                })

                  
            });
        },
        getList() {
            getIvJobApplicantAnalysis(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        getList2() {
            getIvJobDateWeekList(this.formDatas).then((res) => {
                this.getIvJobDateWeekList_data = res.data;
            });
        },
    },
};
</script>
  
<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
  